export default __webpack_public_path__ + "static/media/cookie_background_right.4e9b4914.png";